<template>
	<div :id="'draw' + _uid" class="draw">
		<v-card>
			<v-card-text class="pb-2" :class="results ? 'pt-2' : 'pt-0'">
				<v-row v-if="(panel == 2 || panel == 3 || panel == 4) && !results" no-gutters class="buttons pa-1" justify="center" align="center">
					<!-- <button @click="download()" class="btn submitBtn">
						<img src="../../assets/icons/download.svg" alt="Download" />
					</button> -->
					<!-- <v-btn icon @click="download()">
						<v-icon>mdi-download</v-icon>
					</v-btn>
					<v-divider vertical></v-divider> -->
					<v-btn-toggle v-model="mode" mandatory color="primary" dense group>
						<v-btn value="select" class="text-overline">
							<v-icon color="primary">mdi-cursor-default</v-icon>
						</v-btn>
						<v-btn value="free-hand" class="text-overline" :disabled="cantDraw">
							<v-icon color="primary">mdi-lead-pencil</v-icon>
						</v-btn>
						<!-- <v-btn value="figures" class="text-overline">
							<v-icon color="primary">mdi-drawing-box</v-icon>
						</v-btn> -->
					</v-btn-toggle>
					<!-- <v-btn-toggle v-if="mode == 'figures'" v-model="figure" mandatory color="primary" dense group>
						<v-btn value="rectagle" class="text-overline">
							<v-icon color="primary">mdi-rectangle-outline</v-icon>
						</v-btn>
						<v-btn value="ellipse" class="text-overline">
							<v-icon color="primary">mdi-ellipse-outline</v-icon>
						</v-btn>
					</v-btn-toggle> -->
					<v-divider vertical class="mx-2"></v-divider>
					<v-btn-toggle v-model="display" mandatory color="primary" dense group>
						<v-btn value="regular" class="text-overline">
							<v-icon color="primary">$vuetify.icons.tongueIcon</v-icon>
						</v-btn>
						<v-btn value="fragmented" class="text-overline">
							<v-icon color="primary">$vuetify.icons.tongueIconFragmented</v-icon>
						</v-btn>
					</v-btn-toggle>
					<v-spacer></v-spacer>
					<v-btn v-if="anyRemovableAreaSelected" color="primary" icon @click="deleteSelected()">
						<v-icon>mdi-delete-forever-outline</v-icon>
					</v-btn>
					<v-btn color="primary" icon @click="reset()">
						<v-icon>mdi-refresh-circle</v-icon>
					</v-btn>
					<v-btn color="primary" icon @click="undoLine()">
						<v-icon>mdi-undo-variant</v-icon>
					</v-btn>
				</v-row>
				<v-divider v-if="(panel == 2 || panel == 3 || panel == 4) && !results"></v-divider>
				<v-row no-gutters align="center" justify="center">
					<v-col v-if="results && test.photos.length > 0" cols="3">
            <v-carousel
              height="400"
              hide-delimiter-background
							hide-delimiters
            >
							<v-carousel-item key="canvas">
								<div class="canvas my-2" :key="render">
									<!-- Canvas size is defined in CSS, search for ".canvas" -->
									<template v-if="test.body.shape == 'round'">
										<tongueRoundS :fragmented="display == 'fragmented'" v-if="test.body.size == 'small'" @mounted="initBoard" />
										<tongueRoundN :fragmented="display == 'fragmented'" v-else-if="test.body.size == 'normal'" @mounted="initBoard" />
										<tongueRoundL :fragmented="display == 'fragmented'" v-else @mounted="initBoard" />
									</template>
									<template v-else-if="test.body.shape == 'square'">
										<tongueSquareS :fragmented="display == 'fragmented'" v-if="test.body.size == 'small'" @mounted="initBoard" />
										<tongueSquareN :fragmented="display == 'fragmented'" v-else-if="test.body.size == 'normal'" @mounted="initBoard" />
										<tongueSquareL :fragmented="display == 'fragmented'" v-else @mounted="initBoard" />
									</template>
									<template v-else>
										<tongueTriangleS :fragmented="display == 'fragmented'" v-if="test.body.size == 'small'" @mounted="initBoard" />
										<tongueTriangleN :fragmented="display == 'fragmented'" v-else-if="test.body.size == 'normal'" @mounted="initBoard" />
										<tongueTriangleL :fragmented="display == 'fragmented'" v-else @mounted="initBoard" />
									</template>
									<div id="cursor" :style="{ 'background-color': lineColor, 'display': mode != 'free-hand' ? 'none' : 'block' }"></div>
								</div>
							</v-carousel-item>
              <v-carousel-item v-for="(image, i) in test.photos" :key="i">
                <v-img :src="image.url" height="400" contain/>
              </v-carousel-item>
            </v-carousel>
          </v-col>
					<div v-else class="canvas my-2" :key="render">
						<!-- Canvas size is defined in CSS, search for ".canvas" -->
						<template v-if="test.body.shape == 'round'">
							<tongueRoundS :fragmented="display == 'fragmented'" v-if="test.body.size == 'small'" @mounted="initBoard" />
							<tongueRoundN :fragmented="display == 'fragmented'" v-else-if="test.body.size == 'normal'" @mounted="initBoard" />
							<tongueRoundL :fragmented="display == 'fragmented'" v-else @mounted="initBoard" />
						</template>
						<template v-else-if="test.body.shape == 'square'">
							<tongueSquareS :fragmented="display == 'fragmented'" v-if="test.body.size == 'small'" @mounted="initBoard" />
							<tongueSquareN :fragmented="display == 'fragmented'" v-else-if="test.body.size == 'normal'" @mounted="initBoard" />
							<tongueSquareL :fragmented="display == 'fragmented'" v-else @mounted="initBoard" />
						</template>
						<template v-else>
							<tongueTriangleS :fragmented="display == 'fragmented'" v-if="test.body.size == 'small'" @mounted="initBoard" />
							<tongueTriangleN :fragmented="display == 'fragmented'" v-else-if="test.body.size == 'normal'" @mounted="initBoard" />
							<tongueTriangleL :fragmented="display == 'fragmented'" v-else @mounted="initBoard" />
						</template>
						<div id="cursor" :style="{ 'background-color': lineColor, 'display': mode != 'free-hand' ? 'none' : 'block' }"></div>
					</div>
					<v-col cols="12" v-if="template" no-gutters>
						<v-row no-gutters>
							<v-spacer></v-spacer>
							<v-btn color="primary" class="text-overline mb-2" rounded @click="$emit('set-template')">
								<translate>Aply</translate>
							</v-btn>
						</v-row>
					</v-col>
					<v-card v-if="results || template" outlined>
						<v-card-text>
							<v-row no-gutters>
								<v-col cols="12" class="text-body-1 font-weight-black primary--text">
									<translate>Body</translate>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Color</translate><span class="font-weight-medium ml-1 grey--text">{{bodyColorName}}</span><v-icon class="ml-1" :color="test.body.parts.body.fill" small>mdi-checkbox-blank-circle</v-icon></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Shape</translate><span class="font-weight-medium ml-1 grey--text">{{bodyShapeName}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Size</translate><span class="font-weight-medium ml-1 grey--text">{{bodySizeName}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Tension</translate><span class="font-weight-medium ml-1 grey--text">{{bodyTensionName}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Humidity</translate><span class="font-weight-medium ml-1 grey--text">{{bodyHumidityName}}</span></p>
								</v-col>
							</v-row>
							<v-row v-if="test.cover.exist" no-gutters class="mt-2">
								<v-col cols="12" class="text-body-1 font-weight-black primary--text">
									<translate>Cover</translate>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Area</translate><span class="font-weight-medium ml-1 grey--text">{{coverAreaName}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Quality</translate><span class="font-weight-medium ml-1 grey--text">{{coverQuality}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Thickness</translate><span class="font-weight-medium ml-1 grey--text">{{coverThickness}}</span></p>
								</v-col>
							</v-row>
							<v-row v-if="test.marks.exist" no-gutters class="mt-2">
								<v-col cols="12" class="text-body-1 font-weight-black primary--text">
									<translate>Marks</translate>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Types</translate><span class="font-weight-medium ml-1 grey--text">{{markTypes}}</span></p>
								</v-col>
							</v-row>
							<v-row no-gutters class="mt-2">
								<v-col cols="12" class="text-body-1 font-weight-black primary--text">
									<translate>Movement</translate>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Deviation</translate><span class="font-weight-medium ml-1 grey--text">{{movementType}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Trembling</translate><span class="font-weight-medium ml-1 grey--text"><span v-if="test.movement.trembling" v-translate>Yes</span><span v-translate v-else>No</span></span></p>
								</v-col>
							</v-row>
							<v-row no-gutters class="mt-2">
								<v-col cols="12" class="text-body-1 font-weight-black primary--text">
									<translate>Veins</translate>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Type</translate><span class="font-weight-medium ml-1 grey--text">{{veinsType}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Thickness</translate><span class="font-weight-medium ml-1 grey--text">{{veinsThickness}}</span></p>
								</v-col>
								<v-col cols="12" class="ml-2">
									<p class="font-weight-bold primary--text ma-0"><translate>Tortuosity</translate><span class="font-weight-medium ml-1 grey--text">{{veinsTortuosity}}</span></p>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
					<!-- <v-col md="auto" v-if="test.photos.length > 0">
						<v-carousel
								height="200"
								style="width: 200px"
								hide-delimiter-background
								show-arrows-on-hover
								:show-arrows="test.photos.length > 1"
								hide-delimiters
						>
								<v-carousel-item
									v-for="(image, i) in test.photos"
									:key="i"
								>
									<v-img
										v-if="image.blob"
										:src="image.url"
										height="200"
										contain
									/>
									<v-img
										v-else
										:src="image.image"
										height="200"
										contain
									/>
								</v-carousel-item>
							</v-carousel>
						</v-col> -->
				</v-row>
			</v-card-text>
		</v-card>
		<v-card class="mt-1" v-if="(panel == 2 || panel == 3 || panel == 4) && !results">
			<v-card-text>
				<v-btn style="position: absolute; top: 1" class="text-overline" icon rounded @click="showCanvas = !showCanvas">
					<v-icon large color="primary">mdi-invert-colors</v-icon>
				</v-btn>
				<v-btn style="position: absolute; top: 1; right: 15px" v-if="anyAreaSelected" color="primary" icon @click="blurSelected()">
					<v-icon v-if="selectedAreas[0].getAttributeNS(null, 'filter') != 'url(#blur)'">mdi-blur</v-icon>
					<v-icon v-else>mdi-blur-off</v-icon>
				</v-btn>
				<v-btn v-if="colorPalette == 2" style="position: absolute; top: 120px;" class="text-overline" icon rounded @click="colorPalette = 1">
					<v-icon large color="primary">mdi-chevron-left</v-icon>
				</v-btn>
				<v-btn v-if="colorPalette == 1" style="position: absolute; top: 120px; right: 15px" class="text-overline" icon rounded @click="colorPalette = 2">
					<v-icon large color="primary">mdi-chevron-right</v-icon>
				</v-btn>
				<v-row no-gutters align="center" justify="center">
					<v-color-picker :key="colorKey" mode="rgba" @input="setColor" :swatches="this.colorPalette == 1 ? swatchesBody : swatchesCover" show-swatches hide-inputs :hide-canvas="!showCanvas" hide-mode-switch v-model="currentColor" flat></v-color-picker>
				</v-row>
				<v-row no-gutters align="center" justify="center">
					<span class="font-weight-bold">{{currentColorName}}</span>
				</v-row>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import tongueRoundS from "@/assets/icons/mtc/tongue/tongueRoundS.vue";
import tongueRoundN from "@/assets/icons/mtc/tongue/tongueRoundN.vue";
import tongueRoundL from "@/assets/icons/mtc/tongue/tongueRoundL.vue";
import tongueSquareS from "@/assets/icons/mtc/tongue/tongueSquareS.vue";
import tongueSquareN from "@/assets/icons/mtc/tongue/tongueSquareN.vue";
import tongueSquareL from "@/assets/icons/mtc/tongue/tongueSquareL.vue";
import tongueTriangleS from "@/assets/icons/mtc/tongue/tongueTriangleS.vue";
import tongueTriangleN from "@/assets/icons/mtc/tongue/tongueTriangleN.vue";
import tongueTriangleL from "@/assets/icons/mtc/tongue/tongueTriangleL.vue";
// hello jquery
const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);
export default {
	name: "FreehandDrawSVG",
	props: {
		lineColor: {},
		panel: {},
		markType: {},
		test: {},
		results: {},
		template: {
			default: false
		}
	},
	components: {
		tongueRoundS,
		tongueRoundN,
		tongueRoundL,
		tongueSquareS,
		tongueSquareN,
		tongueSquareL,
		tongueTriangleS,
		tongueTriangleN,
		tongueTriangleL
	},
	data: () => ({
		render: 1,
		colorKey: 1,
		showCanvas: false,
		board: "",
		cursor: "",
		colorNum: 0,
		gesture: false,
		line: "",
		radius: 2.5,
		width: 2.5,
		undo: false,
		onCanvas: false, // mouseout event is not firing, dunno why
		mode: 'select',
		display: 'regular',
		colorPalette: 1,
		selectedAreas: [],
		selectedArea: null,
		offset: null,
		transform: null,
		figure: 'rectangle',
		currentColor: { r: 245, g: 154, b: 154, a: 1 },
		swatchesBody: [
			['#c6a5e2', '#ac83e1', '#9164cc', '#000000'],//violetas 1 2 3 preto
			['#ebdaf5', '#c391aa', '#b76a88', '#923b5d'],//roxos 1 2 3 bordo
			['#fce6e6', '#ffb4b3', '#f59a9a', '#f58282'],//rosado rosa palido
			['#facfcf', '#f5726f', '#f0302c', '#c8100d']//vermelho palido -- vermelho rosado -- vermelho -- vermelho escuro 
		],
		swatchesCover: [
			['#f9f9f8', '#f6f5f3', '#e7e6e1', '#e4e2dc'],
			['#fcf6e4', '#f9e6b7', '#f5d78a', '#f1c85c'],
			['#eeb92f', '#daa311', '#ad810e', '#805f0a'],
			['#c49210', '#96700c', '#694e08', '#3c2c04']
		],
		file: null
	}),
	computed: {
		canvasWidth() {
			return this.board.clientWidth;
		},
		canvasHeight() {
			return this.board.clientHeight;
		},
		anyRemovableAreaSelected() {
			for(let i = 0; i < this.selectedAreas.length; i++) {
				if(this.selectedAreas[i].getAttributeNS(null, "freeDraw")) return true;
			}
			return false;
		},
		anyAreaSelected() {
			return this.selectedAreas.length > 0;
		},
		// requuires some setters, I don't understand it.
		// rect: function(){
		//   return this.board.getBoundingClientRect();
		// },
		// cursorX: function(){
		//   let rect = this.board.getBoundingClientRect();
		//   return Math.round( event.clientX - this.rect.x ) || Math.round(event.changedTouches[0].clientX - this.rect.x)
		// },
		// cursorY: function(){
		//   return Math.round( event.clientY - this.rect.y )  || Math.round(event.changedTouches[0].clientY - this.rect.y)
		// }
    existCover() {
      return this.test.cover.exist;
		},
		existMarks() {
      return this.test.marks.exist;
		},
		hasGrooves() {
			return this.test.marks.grooves;
		},
		hasSpots() {
			return this.test.marks.spots;
		},
		hasTeeth() {
			return this.test.marks.teeth;
		},
		coverArea() {
			return this.test.cover.area;
		},
		bodyShape() {
			return this.test.body.shape;
		},
		bodySize() {
			return this.test.body.size;
		},
		cantDraw() {
			if(this.panel == 3 && !this.test.cover.exist) return true;
			if(this.panel == 4 && !this.test.marks.exist) return true;
			return false;
		},
		drawId() {
			return '#draw' + this._uid + ' ';
		},
		bodyColorName() {
			return this.getColorName(this.stringToRGBObject(this.test.body.parts.body.fill));
		},
		bodyShapeName() {
			if(this.test.body.shape == 'round') return this.$gettext('Round');
			if(this.test.body.shape == 'triangle') return this.$gettext('Triangular');
			return this.$gettext('Square');
		},
		bodySizeName() {
			if(this.test.body.size == 'small') return this.$gettext('Small');
			if(this.test.body.size == 'normal') return this.$gettext('Normal');
			return this.$gettext('Large');
		},
		bodyHumidityName() {
			if(this.test.body.humidity == 0) return this.$gettext('Extremely Dry');
			if(this.test.body.humidity == 1) return this.$gettext('Dry');
			if(this.test.body.humidity == 2) return this.$gettext('Normal');
			if(this.test.body.humidity == 3) return this.$gettext('Wet');
			return this.$gettext('Extremely Wet');
		},
		bodyTensionName() {
			if(this.test.body.tension == 0) return this.$gettext('Extremely Flaccid');
			if(this.test.body.tension == 1) return this.$gettext('Flaccid');
			if(this.test.body.tension == 2) return this.$gettext('Normal');
			if(this.test.body.tension == 3) return this.$gettext('Rigid');
			return this.$gettext('Extremely Rigid');
		},
		coverAreaName() {
			if(this.test.cover.area == 'total') return this.$gettext('Total');
			return this.$gettext('Partial');
		},
		coverQuality() {
			if(this.test.cover.quality == "normal") return this.$gettext('Normal');
			if(this.test.cover.quality == "sticky") return this.$gettext('Sticky');
			return this.$gettext('Geographic');
		},
		coverThickness() {
			if(this.test.cover.thickness == 0) return this.$gettext('Slim');
			if(this.test.cover.thickness == 1) return this.$gettext('Medium');
			return this.$gettext('Thick');
		},
		markTypes() {
			let text = "";
			if(this.test.marks.grooves) text = text + this.$gettext('Grooves') + '; ';
			if(this.test.marks.spots) text = text + this.$gettext('Spots') + '; ';
			if(this.test.marks.teeth) text = text + this.$gettext('Teeth');
			return text;
		},
		movementType() {
			if(this.test.movement.type == 'inexistent') return this.$gettext('Inexistent');
			if(this.test.movement.type == 'left') return this.$gettext('Left');
			return this.$gettext('Right');
		},
		veinsType() {
			if(this.test.veins.type == 'normal') return this.$gettext('Normal');
			return this.$gettext('Changed');
		},
		veinsThickness() {
			if(this.test.veins.thickness == 0) return this.$gettext('Slim');
			if(this.test.veins.thickness == 1) return this.$gettext('Medium');
			return this.$gettext('Thick');
		},
		veinsTortuosity() {
			if(this.test.veins.tortuosity == 0) return this.$gettext('Light');
			if(this.test.veins.tortuosity == 1) return this.$gettext('Moderate');
			return this.$gettext('Sharp');
		},
		currentColorName() {
			return this.getColorName(this.currentColor);
		}
	},
	methods: {
		initBoard() {
			console.log("INIT CANVAS");
			this.board = $(this.drawId + ".canvas svg");
			this.cursor = $(this.drawId + "#cursor");
			this.gesture = false;

			//SET OUTSIDE
			let outside = $(this.drawId + '.canvas #outside');
			outside.addEventListener("click", this.clickOutside);

			//SET BODY PARTS
			for (const [ key, value ] of Object.entries(this.test.body.parts)) {
				let path = $(this.drawId + '.canvas ' + '#' + key);
				path.style.fill = value.fill;
				path.setAttributeNS(null, "filter", value.filter);
				path.addEventListener("click", this.clickDrawnPath);
			}

			//SET COVER PARTS
			for (const [ key, value ] of Object.entries(this.test.cover.parts)) {
				let path = $(this.drawId + '.canvas ' + '#' + key);
				path.style.fill = value.fill;
				path.setAttributeNS(null, "filter", value.filter);
				path.addEventListener("click", this.clickDrawnPath);
			}

			//SET LISTENERS FOR DRAWING
			let draw = this;
			if(!this.results) {
				this.board.addEventListener('mousedown', function() {
					draw.linestart();
				})
				this.board.addEventListener('touchstart', function() {
					draw.linestart();
				})
				this.board.addEventListener('mousemove', function() {
					draw.lineMove();
				})
				this.board.addEventListener('touchmove', function() {
					draw.lineMove();
				})
				this.board.addEventListener('mouseup', function() {
					draw.lineEnd();
				})
				this.board.addEventListener('touchend', function() {
					draw.lineEnd();
				})
				this.board.addEventListener('onmouseleave', function() {
					draw.outOfCanvas();
				})
				this.board.addEventListener('touchcancel', function() {
					draw.outOfCanvas();
				})
			}

			//SET COLORS FOR PARTS AND DRAW ALL ELEMENTS
			for(let i = 0; i < this.test.body.elements.length; i++) {
				this.drawPath(this.test.body.elements[i]);
			}
			for(let i = 0; i < this.test.cover.elements.length; i++) {
				this.drawPath(this.test.cover.elements[i]);
			}
			for(let i = 0; i < this.test.marks.elements.length; i++) {
				this.drawPath(this.test.marks.elements[i]);
			}

			if(this.results && this.panel == 0 && this.test.photos.length == 0) this.$emit('close-panel');
			
			this.setLayerToFront('cover_layer');
		},
		setColor() {
			console.log("SET COLOR");
			for(let i = 0; i < this.selectedAreas.length; i++) {
				let r = this.currentColor.r;
				let g = this.currentColor.g;
				let b = this.currentColor.b;
				let a = this.currentColor.a;
				if(a == undefined) {a = 1; console.log("undefined");}
				let color = 'rgba' + '(' + r + ',' + g + ',' + b + ',' + a + ')';
				console.log(color);
				if(this.selectedAreas[i].getAttributeNS(null, "freeDraw")) {
					this.selectedAreas[i].setAttributeNS(null, "fill", color);
					this.selectedAreas[i].setAttributeNS(null, "stroke", color);
				} else {
					this.selectedAreas[i].style.fill = color;
					if(this.selectedAreas[i].id == 'body') {
						for (const [ key ] of Object.entries(this.test.body.parts)) {
							let path = $(this.drawId + '.canvas ' + '#' + key);
							path.style.fill = color;
						}
					}
				}
			}
		},
		linestart() {
			if(this.mode == 'free-hand') {
				console.log("LINE START");
				this.undo = true;
				let e = event;
				// this.line += 'M' + this.cursorX + ',' + this.cursorY
				// I prefer to use code above with computed valuse, but it drops some errors about setter, and I didn't succeed to solve it in 15 minutes.
				let rect = this.board.getBoundingClientRect();
				let cursorX =
					Math.round(e.clientX - rect.x) ||
					Math.round(e.changedTouches[0].clientX - rect.x);
				let cursorY =
					Math.round(e.clientY - rect.y) ||
					Math.round(e.changedTouches[0].clientY - rect.y);
				this.line += "M" + cursorX + "," + cursorY;
				this.cursor.style.opacity = 1;
				this.gesture = true;
				e.preventDefault();
			}
		},
		lineMove() {
			if(this.mode == 'free-hand') {
				let e = event;
				let rect = this.board.getBoundingClientRect();
				let cursorX =
					Math.round(e.clientX - rect.x) ||
					Math.round(e.changedTouches[0].clientX - rect.x);
				let cursorY =
					Math.round(e.clientY - rect.y) ||
					Math.round(e.changedTouches[0].clientY - rect.y);
				if (this.gesture == true) {
					this.line += "L" + cursorX + "," + cursorY;
					// this.line += 'L'+(e.clientX||e.touches[0].clientX)+','+(e.clientY||e.touches[0].clientY)+' '
					this.trace(
						e.clientX || e.touches[0].clientX,
						e.clientY || e.touches[0].clientY
					);
				}
				this.cursor.style.top = e.clientY - rect.y - this.radius + "px";
				this.cursor.style.left = e.clientX - rect.x - this.radius + "px";
				this.cursorX = e.clientX - rect.x;
				this.cursorY = e.clientY - rect.y;
				this.onCanvas = true;
			}
		},
		trace(x, y) {
			let dot = document.createElement("div");
			dot.classList.add("dot");
			dot.style.top = y - this.radius + "px";
			dot.style.left = x - this.radius + "px";
			dot.style.background = this.lineColor;
			dot.style.width = dot.style.height = this.radius * 2 + "px";
			document.body.appendChild(dot);
			console.log("move");
			setTimeout(function() {
				dot.style.opacity = 0.2;
			}, 500);
			//setTimeout(function() {
			//	document.body.removeChild(dot);
			//}, 1500);
		},
		lineEnd() {
			if(this.mode == 'free-hand') {
				let e = event;
				let rect = this.board.getBoundingClientRect();
				let cursorX =
					Math.round(e.clientX - rect.x) ||
					Math.round(e.changedTouches[0].clientX - rect.x);
				let cursorY =
					Math.round(e.clientY - rect.y) ||
					Math.round(e.changedTouches[0].clientY - rect.y);
				this.line += "L" + cursorX + "," + cursorY;
				// this.line += 'L'+(e.clientX||e.changedTouches[0].clientX)+','+(e.clientY||e.changedTouches[0].clientY)
				this.cursor.style.opacity = 0.5;
				
				let color = 'rgba' + '(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ',' + this.currentColor.a + ')';
				let pathObject = {
					'd': this.line,
					'fill': color,
					'stroke-linecap': "round",
					'stroke-linejoin': "round",
					'stroke': color,
					'stroke-width': this.width,
					'filter': null
				}
				
				if(this.panel == 2) {
					pathObject.type = "body";
					//this.test.body.elements.push(pathObject)
				}
				else if(this.panel == 3) {
					pathObject.type = "cover";
					//this.test.cover.elements.push(pathObject)
				}
				else if(this.panel == 4) {
					pathObject.type = "mark";
					pathObject.kind = this.markType;
					this.test.marks[this.markType] = true;
					//this.test.cover.elements.push(pathObject)
				}

				console.log("REMOVE DOTS");
				let dots = $$('.dot');
				for(let i = 0; i < dots.length; i++) {
					document.body.removeChild(dots[i]);
				}

				let path = this.drawPath(pathObject);

				this.resetSelectors();
				path.setAttribute("selected", "true");
				this.selectedAreas = [path];

				console.log(path);
				this.gesture = false;
				this.line = "";
				console.log("LINE END");
			}
		},
		drawPath(data) {
			let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
			path.setAttributeNS(null, "d", data['d']);
			path.setAttributeNS(null, "fill", data['fill']);
			path.setAttributeNS(null, "stroke-linecap", data['stroke-linecap']);
			path.setAttributeNS(null, "stroke-linejoin", data['stroke-linejoin']);
			path.setAttributeNS(null, "stroke", data['stroke']);
			path.setAttributeNS(null, "stroke-width", data['stroke-width']);
			path.setAttributeNS(null, "filter", data['filter']);
			path.setAttribute("freeDraw", "true");
			path.setAttribute("type", data['type']);
			if(data['type'] == 'mark') path.setAttribute("kind", data['kind']);

			if(!this.results) {
				path.addEventListener("click", this.clickDrawnPath);
				path.addEventListener("mousedown", this.startDrag);
				path.addEventListener("mousemove", this.drag);
				path.addEventListener("mouseup", this.endDrag);
				path.addEventListener("mouseleave", this.endDrag);
			}

			if(data['type'] == 'body') $(this.drawId + ".canvas #body_layer").appendChild(path);
			else if(data['type'] == 'cover' || data['type'] == 'mark') $(this.drawId + ".canvas #cover_layer").appendChild(path);

			return path
		},
		clickDrawnPath(e) {
			if(this.mode != 'select') return 0;
			if(this.panel != 2 && this.panel != 3 && this.panel != 4) return 0;
			if(this.panel == 3) {
				if(!this.test.cover.exist) return 0;
				if(this.test.cover.exist && this.test.cover.area == 'partial' && e.target.id == 'cover') return 0;
				if(e.target.id != 'cover' && e.target.getAttributeNS(null, "type") != 'cover') return 0;
			}
			if(this.panel == 4) {
				if(e.target.id == 'cover') return 0;
				if(e.target.getAttributeNS(null, "type") != 'mark') return 0;
			}
			let selectedArea = e.target;
			let selected = selectedArea.getAttributeNS(null, "selected");
			if(selected) {
				console.log("already selected");
				selectedArea.removeAttribute("selected");
				this.selectedAreas.splice(this.selectedAreas.indexOf(selectedArea), 1);
				//this.selectedArea = null;
			}
			else {
				if(this.panel == 3) {
					this.resetSelectors();
					this.selectedAreas = [selectedArea];
				} else {
					this.selectedAreas.push(selectedArea);
				}
				//this.selectedArea = selectedArea;
				console.log("selected");
				selectedArea.setAttribute("selected", "true");
				//this.currentColor = selectedArea.style.fill;
				let rgbaColor = selectedArea.style.fill;
				if(!rgbaColor) rgbaColor = selectedArea.getAttributeNS(null, "fill");
				console.log(rgbaColor);
				let rgbaList = rgbaColor.replace(/^(rgb|rgba)\(/,'').replace(/\)$/,'').replace(/\s/g,'').split(',');
				let r = Number(rgbaList[0]);
				let g = Number(rgbaList[1]);
				let b = Number(rgbaList[2]);
				let a = rgbaList[3];
				if(a == undefined) a = 1;
				this.currentColor.r = r;
				this.currentColor.g = g;
				this.currentColor.b = b;
				this.currentColor.a = Number(a);
				console.log(rgbaList);
				this.colorKey += 1;
			}
		},
    getMousePosition(evt) {
      var CTM = $(this.drawId + '.canvas svg').getScreenCTM();
      return {
        x: (evt.clientX - CTM.e) / CTM.a,
        y: (evt.clientY - CTM.f) / CTM.d
      }
    },
		startDrag(evt) {
			if(this.mode != 'select') return 0;
			console.log("START DRAG");
			this.selectedArea = evt.target;
			this.offset = this.getMousePosition(evt);
			// Get all the transforms currently on this element
			var transforms = this.selectedArea.transform.baseVal;
			// Ensure the first transform is a translate transform
			if (transforms.length === 0 || transforms.getItem(0).type !== SVGTransform.SVG_TRANSFORM_TRANSLATE) {
				// Create an transform that translates by (0, 0)
				var translate = $(this.drawId + '.canvas svg').createSVGTransform();
				translate.setTranslate(0, 0);
				// Add the translation to the front of the transforms list
				this.selectedArea.transform.baseVal.insertItemBefore(translate, 0);
			}
			// Get initial translation amount
			this.transform = transforms.getItem(0);
			this.offset.x -= this.transform.matrix.e;
			this.offset.y -= this.transform.matrix.f;
		},
		drag(evt) {
			if (this.selectedArea) {
				console.log("DRAG");
				evt.preventDefault();
				var coord = this.getMousePosition(evt);
				this.transform.setTranslate(coord.x - this.offset.x, coord.y - this.offset.y);
			}
		},
		endDrag(evt) {
			if(this.selectedArea) {
				console.log("END DRAG", evt);
				this.selectedArea = null;
			}
		},
		undoLine() {
			this.resetSelectors();
			let paths = [];
			let layer;
			if(this.panel == 2) {
				paths = $$(this.drawId + ".canvas #body_layer path");
				layer = $(this.drawId + ".canvas #body_layer");
			} else if(this.panel == 3) {
				paths = $$(this.drawId + ".canvas #cover_layer path[type='cover']");
				layer = $(this.drawId + ".canvas #cover_layer");
			} else if(this.panel == 4) {
				paths = $$(this.drawId + ".canvas #cover_layer path[type='mark']");
				layer = $(this.drawId + ".canvas #cover_layer");
			}
			console.log(paths);
			if(paths.length > 0) {
				if(paths[paths.length - 1].getAttributeNS(null, "freeDraw")) {
					console.log("UNDO", paths[paths.length - 1]);
					layer.removeChild(paths[paths.length - 1]);
					if(!layer.hasChildNodes()) this.undo = false;
				}
			}
		},
		reset() {
			this.line = "";
			this.undo = false;
			let allPaths = [];
			let layer;
			if(this.panel == 2) {
				allPaths = $$(this.drawId + ".canvas #body_layer path");
				layer = $(this.drawId + ".canvas #body_layer");
			} else if(this.panel == 3) {
				allPaths = $$(this.drawId + ".canvas #cover_layer path[type='cover']");
				layer = $(this.drawId + ".canvas #cover_layer");
			} else if(this.panel == 4) {
				allPaths = $$(this.drawId + ".canvas #cover_layer path[type='mark']");
				layer = $(this.drawId + ".canvas #cover_layer");
				this.test.marks.grooves = false;
        this.test.marks.teeth = false;
        this.test.marks.spots = false;
			}
			console.log(allPaths);
			for (let i = 0; i < allPaths.length; i++) {
				if(allPaths[i].getAttributeNS(null, "freeDraw")) {
					console.log("REMOVE", allPaths[i]);
					layer.removeChild(allPaths[i]);
				} else {
					console.log("SET COLOR", allPaths[i]);
					if(allPaths[i].getAttributeNS(null, 'id') == 'cover') {
						if(this.existCover) {
							allPaths[i].style.fill = 'rgba(255, 255, 255, 0.5)';
						} else {
							allPaths[i].style.fill = 'rgba(255, 255, 255, 0)';
						}
					}
					allPaths[i].style.fill = 'rgb(245,154,154,1)';
				}
			}
			this.resetSelectors();
			this.selectedArea = null;
		},
		deleteSelected() {
			console.log(this.selectedAreas.length);
			for(let i = 0; i < this.selectedAreas.length; i++) {
				if(this.selectedAreas[i].getAttributeNS(null, "freeDraw")) {
					console.log("DELETE", this.selectedAreas[i]);
					this.selectedAreas[i].remove();
				}
			}
			this.selectedAreas = [];
		},
		blurSelected() {
			for(let i = 0; i < this.selectedAreas.length; i++) {
				console.log("BLUR", this.selectedAreas[i]);
				if(this.selectedAreas[i].getAttributeNS(null, "filter") != "url(#blur)") this.selectedAreas[i].setAttributeNS(null, "filter", "url(#blur)");
				else this.selectedAreas[i].removeAttribute("filter");
			}
		},
		download() {
			var dl = document.createElement("a");
			let drawing = this.svgDataURL($(".drawSvg"));
			console.log(drawing);
			document.body.appendChild(dl); // This line makes it work in Firefox.
			dl.setAttribute("href", drawing);
			dl.setAttribute("download", "freehand-svg-drawing.svg");
			dl.click();
		},
		svgDataURL() {
			// let drawSvg = new XMLSerializer().serializeToString(this.board)
			let serialSvg = new XMLSerializer().serializeToString(this.board);
			return "data:image/svg+xml," + encodeURIComponent(serialSvg);

			// this.$emit('drawSubmit', drawSvg);
		},
		resetSelectors() {
			let paths = document.querySelectorAll(this.drawId + '.canvas path');
			for (let i = 0; i < paths.length; i++) {
				paths[i].removeAttribute("selected");
			}
			this.selectedAreas = [];
		},
		resetMode() {
			this.mode = 'select';
		},
		saveState() {
			console.log("SAVE STATE");
			//SAVE BODY PARTS
			for (const [ key, value ] of Object.entries(this.test.body.parts)) {
				let path = $(this.drawId + '.canvas ' + '#' + key);
				value.fill = path.style.fill;
				value.filter = path.getAttributeNS(null, "filter");
			}

			//SAVE COVER PARTS
			for (const [ key, value ] of Object.entries(this.test.cover.parts)) {
				let path = $(this.drawId + '.canvas ' + '#' + key);
				value.fill = path.style.fill;
				value.filter = path.getAttributeNS(null, "filter");
			}

			//SAVE BODY ELEMENTS
			this.test.body.elements.length = [];
			let bodyPaths = $$(this.drawId + '.canvas #body_layer path');
			for(let i = 0; i < bodyPaths.length; i++) {
				if(bodyPaths[i].getAttributeNS(null, "freeDraw")) {
					this.test.body.elements.push({
						'type': bodyPaths[i].getAttributeNS(null, "type"),
						'd': bodyPaths[i].getAttributeNS(null, "d"),
						'fill': bodyPaths[i].getAttributeNS(null, "fill"),
						'stroke-linecap': bodyPaths[i].getAttributeNS(null, "stroke-linecap"),
						'stroke-linejoin': bodyPaths[i].getAttributeNS(null, "stroke-linejoin"),
						'stroke': bodyPaths[i].getAttributeNS(null, "stroke"),
						'stroke-width': bodyPaths[i].getAttributeNS(null, "stroke-width"),
						'filter': bodyPaths[i].getAttributeNS(null, "filter")
					});
				}
			}
			
			//SAVE COVER AND MARK ELEMENTS
			this.test.cover.elements = [];
			this.test.marks.elements = [];
			let coverPaths = $$(this.drawId + '.canvas #cover_layer path');
			for(let i = 0; i < coverPaths.length; i++) {
				if(coverPaths[i].getAttributeNS(null, "freeDraw")) {
					let path = {
						'type': coverPaths[i].getAttributeNS(null, "type"),
						'kind': coverPaths[i].getAttributeNS(null, "kind"),
						'd': coverPaths[i].getAttributeNS(null, "d"),
						'fill': coverPaths[i].getAttributeNS(null, "fill"),
						'stroke-linecap': coverPaths[i].getAttributeNS(null, "stroke-linecap"),
						'stroke-linejoin': coverPaths[i].getAttributeNS(null, "stroke-linejoin"),
						'stroke': coverPaths[i].getAttributeNS(null, "stroke"),
						'stroke-width': coverPaths[i].getAttributeNS(null, "stroke-width"),
						'filter': coverPaths[i].getAttributeNS(null, "filter")
					}
					if(path.type == 'cover') this.test.cover.elements.push(path);
					else if(path.type == 'mark') this.test.marks.elements.push(path);
				}
			}
		},
		clickUpload() {
			console.log(this.$refs.fileInput);
			this.$refs.fileInput.$el.click();
			this.$refs.fileInput.$el.click();
		},
		clickOutside() {
			this.resetSelectors();
			this.mode = 'select';
		},
		removeMarks(kind) {
			let allPaths = $$(this.drawId + ".canvas #cover_layer path[type='mark'][kind=" + "'" + kind + "'" + "]");
			let layer = $(this.drawId + ".canvas #cover_layer");
			for (let i = 0; i < allPaths.length; i++) {
				if(allPaths[i].getAttributeNS(null, "freeDraw")) {
					console.log("REMOVE", allPaths[i]);
					layer.removeChild(allPaths[i]);
				}
			}
		},
		selectMarks(kind) {
			let allPaths = $$(this.drawId + ".canvas #cover_layer path[type='mark'][kind=" + "'" + kind + "'" + "]");
			for (let i = 0; i < allPaths.length; i++) {
				console.log(allPaths[i]);
				if(allPaths[i].getAttributeNS(null, "freeDraw")) {
					this.selectedAreas.push(allPaths[i]);
					allPaths[i].setAttribute("selected", "true");
				}
			}
		},
		getColorName(color) {
			if(color.r == 245 && color.g == 154 || color.b == 154) return 'Rosado';
			if(color.r == 255 && color.g == 180 || color.b == 179) return 'Rosado';
			if(color.r == 245 && color.g == 130 || color.b == 130) return 'Rosado';
			if(color.r == 252 && color.g == 230 || color.b == 230) return 'Rosa Pálido';
			if(color.r == 250 && color.g == 207 || color.b == 207) return 'Vermelho Pálido';
			if(color.r == 245 && color.g == 114 || color.b == 111) return 'Vermelho Rosado';
			if(color.r == 240 && color.g == 48 || color.b == 44) return 'Vermelho';
			if(color.r == 200 && color.g == 16 || color.b == 13) return 'Vermelho Escuro';
			if(color.r == 235 && color.g == 218 || color.b == 245) return 'Roxo';
			if(color.r == 195 && color.g == 145 || color.b == 170) return 'Roxo';
			if(color.r == 182 && color.g == 106 || color.b == 136) return 'Roxo';
			if(color.r == 146 && color.g == 59 || color.b == 93) return 'Bordô';
			if(color.r == 198 && color.g == 165 || color.b == 226) return 'Violeta';
			if(color.r == 172 && color.g == 131 || color.b == 225) return 'Violeta';
			if(color.r == 145 && color.g == 100 || color.b == 204) return 'Violeta';
			if(color.r == 0 && color.g == 0 || color.b == 0) return 'Preto';
			return 'Outra';
		},
		stringToRGBObject(colorString) {
			let rgbaList = colorString.replace(/^(rgb|rgba)\(/,'').replace(/\)$/,'').replace(/\s/g,'').split(',');
			let rbgObject = {
				r: Number(rgbaList[0]),
				g: Number(rgbaList[1]),
				b: Number(rgbaList[2])
			}
			return rbgObject;
		},
		setLayerToFront(layer) {
			let layers = $$(this.drawId + '.canvas svg g');
			if(layers[0].id == 'body_layer' && layer == 'body_layer') this.board.insertBefore(layers[1], layers[0]);
			if(layers[0].id == 'cover_layer' && layer == 'cover_layer') this.board.insertBefore(layers[1], layers[0]);
		},
		rerenderSVG() {
			console.log("RERENDER");
			this.render += 1;
		}
	},
	watch: {
		mode() {
			this.resetSelectors();
		},
		panel(newValue) {
			this.resetSelectors();
			let layers = $$(this.drawId + '.canvas svg g');
			if((newValue == 2 && layers[1].id == 'cover_layer') || (newValue != 2 && layers[1].id == 'body_layer')) {
				this.board.insertBefore(layers[1], layers[0]);
			}
			if(newValue == 2) {
				this.colorPalette = 1;
				if(this.display == 'regular' && !this.results) {
					let body = $(this.drawId + '.canvas svg #body');
					this.clickDrawnPath({target: body});
				}
			}
			if(newValue == 3) this.colorPalette = 2;
			this.mode = 'select';
		},
		existCover(newValue) {
			if(newValue && this.test.cover.area == 'total') {
				console.log("EXIST COVER");
				this.resetSelectors();
				let cover = $(this.drawId + '.canvas #cover');
				cover.style.fill = 'rgba(255, 255, 255, 0.5)';
				this.clickDrawnPath({target: cover});
			}
			else {
				console.log("DOESNT EXIST COVER");
				this.resetSelectors();
				this.reset();
				$(this.drawId + '.canvas #cover').style.fill = 'rgba(255, 255, 255, 0)';
			}
		},
		existMarks(newValue) {
			if(!newValue) {
				this.resetSelectors();
				this.reset();
				this.resetMode();
			}
		},
		markType(newValue) {
			this.resetSelectors();
			this.selectMarks(newValue);
		},
		hasGrooves(newValue) {
			if(!newValue) {
				this.removeMarks('grooves');
			}
		},
		hasSpots(newValue) {
			if(!newValue) {
				this.removeMarks('spots');
			}		
		},
		hasTeeth(newValue) {
			if(!newValue) {
				this.removeMarks('teeth');
			}
		},
		coverArea(newValue) {
			if(newValue == 'total') {
				this.resetSelectors();
				let cover = $(this.drawId + '.canvas #cover');
				cover.style.fill = 'rgba(255, 255, 255, 0.5)';
				this.clickDrawnPath({target: cover});
			} else {
				this.resetSelectors();
				$(this.drawId + '.canvas #cover').style.fill = 'rgba(255, 255, 255, 0)';
			}
		},
		bodyShape() {
			if(this.panel == 2) this.saveState();
		},
		bodySize() {
			if(this.panel == 3) this.saveState();
		},
		test() {
			console.log("CHANGE TEST");
			this.rerenderSVG();
		}
		// display(newValue) {
		// 	let paths = $$(this.drawId + '.canvas #body_layer path');
		// 	if(newValue == 'fragmented') {
		// 		for(let i = 0; i < paths.length; i++) {
		// 			if(!paths[i].getAttributeNS(null, "freeDraw") && paths[i].id != 'body') paths[i].style.stroke = '#000000';
		// 		}
		// 	} else {
		// 		for(let i = 0; i < paths.length; i++) {
		// 			if(!paths[i].getAttributeNS(null, "freeDraw") && paths[i].id != 'body') paths[i].style.stroke = 'none';
		// 		}
		// 	}
		// }
	}
};
</script>


<style>
.canvas{
  position: relative;
  overflow: hidden;
}

.canvas path[selected] {
  stroke-width: 3px !important;
  stroke: #504848 !important;
  stroke-dasharray: 5,5 !important;
}

#cursor{
	top: 50%;
	left: 50%;
}

#cursor, .dot {
	display: block;
	width: 5px;
	height: 5px;
	border-radius: 100%;
	position: absolute;
	opacity: .5;
	pointer-events: none;
	transition: opacity .1s ease-in-out;
	z-index: 400;
}

@media only screen and (max-width: 720px) {

	body, html{
		background: #2E2F30 !important;
		align-items: flex-start !important;
	}

	.canvas{
		top: 70px;
	}

	#cursor{
		display: none;
	}

}
</style>